import { OpenCvProvider } from "opencv-react";
import HomePage2Core from "./HomePage2Core";

export default function HomePage2() {
  return (
    <OpenCvProvider openCvPath={`/opencv.js`}>
      <HomePage2Core />
    </OpenCvProvider>
  );
}
